<template>
<div class="section-information-catalog">
	<div class="title-section">
		En <span class="text-green">CasaMarket</span> hemos construido un <span class="text-green">sistema escalonado</span> para ayudarte a incrementar tus ventas online y gestionar tu negocio
	</div>
</div>
</template>

<script>
export default {
	name: 'section-information-catalog',
};
</script>

<style lang="scss" scoped>
.section-information-catalog {
	background-image: linear-gradient(to bottom, rgba(251, 253, 253, 0), rgba(248, 252, 252, 0.48) 17%, #f5fbfb);
	padding: 40px 32px;
	font-size: map-get($sizes, large);
	@media (min-width: 936px) {
		padding: 65px 0 55px 0;
		font-size: map-get($sizes, large25);
	}
}
.title-section {
	color: map-get($colors, newwarning);
	font-size: map-get($sizes, large25) !important;
	margin: 0 auto;
	max-width: 720px;
	text-align: center;
}
.text-green {
	color: map-get($colors, primary);
	font-weight: map-get($weight, black);
}
</style> 



// WEBPACK FOOTER //
// src/components/home-new/section-information-catalog.vue